import { RefreshCw } from '../icons';
import { Button } from '../components/ui/button';

const REFRESH_FAILED_TEXT = "Couldn't refresh";
const RETRY_LABEL = 'Retry';

interface ReportRefreshNoticeProps {
  onRetry: () => void;
}

/** Shown over a report that is still the last good one because its refetch failed. */
export function ReportRefreshNotice({ onRetry }: ReportRefreshNoticeProps) {
  return (
    <div role="status" className="flex items-center gap-1 text-caption-regular text-muted-foreground">
      <span>{REFRESH_FAILED_TEXT} ·</span>
      <Button type="button" variant="link" size="sm" className="h-auto p-0 text-caption-regular" onClick={onRetry}>
        <RefreshCw size={12} className="size-3" /> {RETRY_LABEL}
      </Button>
    </div>
  );
}
